let slideIndex = 0;
carousel();

function carousel() {
  const $slides = $('.testimonials-carousel__slider-slide');

  // Hide all slides using jQuery CSS method
  $slides.css({
    'opacity': '0',
    'transform': 'translateY(8px)'
  });

  slideIndex++;
  if (slideIndex > $slides.length) { slideIndex = 1; }

  // Show the active slide
  $slides.eq(slideIndex - 1).css({
    'opacity': '1',
    'transform': 'translateY(0)'
  });

  setTimeout(carousel, 5000);
}
